import { Stack } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { api, getQueryProps } from 'common';

import { useFlowDefinitionContext } from '../../../../context';
import { BlockSelectField } from '../../ConfigFields/SelectField';
import { SharedRestBlockFormFields } from '../Rest/Shared/FormFields';

export function RestApiClassicAuthorizationBlockFormFields() {
  const {
    flowDefinition: { organizationId },
  } = useFlowDefinitionContext();

  const { data: apiInstances = [] } = useQuery({
    ...getQueryProps(api.client.Orchestrator.ApiInstance, 'findAllBasic', {
      organizationId,
    }),
  });

  return (
    <Stack spacing={2}>
      <BlockSelectField
        label="API Instance"
        fieldName="config.apiInstanceId"
        required={true}
        helperText={
          apiInstances.length === 0
            ? 'No API instances available for this organization. Please create one first.'
            : `Select the API instance to use for FHIR requests. Only API instances from this flow's organization are shown.`
        }
        options={apiInstances.map((apiInstance) => ({
          label: apiInstance.name,
          value: apiInstance.id,
        }))}
      />
      <SharedRestBlockFormFields />
    </Stack>
  );
}
